import { Routes } from '@angular/router';
import { authGuardModule } from './core/auth-guard/auth-guard';
import { actingClientGuard } from './core/auth-guard/acting-client-guard';
import { CLIENT_SHELL_CHILD_ROUTES } from './core/constants/client-shell-routes';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./features/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./features/onboarding/onboarding.module').then(
        (m) => m.OnboardingModule
      ),
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./features/admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'client',
    loadChildren: () =>
      import('./features/client/client.module').then((m) => m.ClientModule),
  },
  {
    path: 'clients',
    canActivate: [authGuardModule],
    loadComponent: () =>
      import('./pages/layout/client-shell/client-shell').then((m) => m.ClientShell),
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./pages/admin/clients/select-client-list/select-client-list').then(
            (m) => m.SelectClientList
          ),
        data: { title: 'Select Client' },
      },
      {
        path: ':clientId',
        canActivate: [actingClientGuard],
        children: CLIENT_SHELL_CHILD_ROUTES,
      },
    ],
  },
  {
    path: 'access-denied',
    loadComponent: () =>
      import('./pages/common/access-denied/access-denied').then((m) => m.AccessDenied),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/common/access-denied/access-denied').then((m) => m.AccessDenied),
    data: { code: 404 },
  },
];
